import React from "react";

type Props = {
  onBack?: () => void;
};

const MusicBoombox: React.FC<Props> = ({ onBack }) => {
  return (
    <section aria-label="Music" className="music-brutalist">
      <header className="panel-header">
        <h2 style={{ margin: 0 }}>Music</h2>
        {onBack && (
          <button className="btn" onClick={onBack} aria-label="Back to blog">
            ← Back
          </button>
        )}
      </header>
      <div className="panel">
        <iframe
          src="/seeward-music/index.html"
          title="Seeward Boombox"
          className="music-boombox-iframe"
          scrolling="no"
          aria-hidden="false"
          style={{ background: "transparent" }}
        />
      </div>

      <style>
        {`
          /* Constrain music section to match blog list width */
          .music-brutalist .panel-header,
          .music-brutalist .panel {
            /* Use same variables as blog with safe fallbacks */
            width: calc(100% - var(--post-list-narrow-by, 200px));
            margin-left: calc(0px - var(--post-list-shift-left, 0px));
          }

          .panel-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 0 0 12px;
          }
          .panel {
            border: 6px solid #000;
            box-shadow: 10px 10px 0 #000;
            background: #fff;
            padding: 0; /* let iframe use full width */
            text-align: left;
            overflow: hidden;
          }
          .btn {
            border: 3px solid #000;
            box-shadow: 3px 3px 0 #000;
            background: #fff;
            padding: 8px 12px;
            font-weight: 800;
            cursor: pointer;
          }
          .music-boombox-iframe {
            display: block;
            width: 100%;
            aspect-ratio: 2 / 1; /* match Phaser config 800x400 */
            height: auto;
            min-height: 600px; /* ~2x previous 300px embed */
            border: none;
          }
          @media (max-width: 760px) {
            .music-brutalist .panel-header,
            .music-brutalist .panel { width: 100%; margin-left: 0; }
            .music-boombox-iframe { min-height: 420px; }
          }
        `}
      </style>
    </section>
  );
};

export default MusicBoombox;
